(function () {
    'use strict';

    angular
        .module('szallodak-payment-term', []);
})();
